import { BaseDropdownInterface } from '@interfaces/base-dropdown.interface';

export const SNOOZE_TIME_RANGE: BaseDropdownInterface[] = [
  { id: '15', name: '15 minutes' },
  { id: '30', name: '30 minutes' },
  { id: '45', name: '45 minutes' },
  { id: '60', name: '1 hour' },
];
